import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, AlertTriangle } from 'lucide-react';
import { verifyCheckout } from '../api/services';
import { useSubscription } from '../context/SubscriptionContext';

const SubscribeSuccess = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useSubscription();
  const [status, setStatus] = useState('verifying');
  const [info, setInfo] = useState(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return; ranRef.current = true;
    const orderId = params.get('orderId') || params.get('order_id') || params.get('order') || '';
    const plan = params.get('plan') || 'basic';
    const interval = params.get('interval') || 'monthly';
    let attempts = 0;
    let timer;

    const poll = async () => {
      attempts += 1;
      try {
        const res = await verifyCheckout(orderId, plan, interval);
        if (res.status === 'active') {
          setStatus('success');
          setInfo(res);
          await refresh();
          setTimeout(() => nav('/profiles', { replace: true }), 2200);
          return;
        }
      } catch (e) {
        // pass
      }
      if (attempts < 8) {
        timer = setTimeout(poll, 1500);
      } else {
        setStatus('pending');
      }
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center p-10 rounded-2xl bg-white/5 border border-white/10 backdrop-blur">
        {status === 'verifying' && (
          <>
            <div className="mx-auto w-14 h-14 rounded-full border-4 border-white/10 border-t-[#E50914] animate-spin" />
            <h2 className="mt-5 text-2xl font-semibold">Confirming your subscription…</h2>
            <p className="text-white/60 mt-2">Hang tight, this only takes a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-400" size={56} />
            <h2 className="mt-4 text-2xl font-semibold">You're in.</h2>
            <p className="text-white/60 mt-2">Welcome to BLUNT TV {info?.plan}. Redirecting to your profile…</p>
          </>
        )}
        {status === 'pending' && (
          <>
            <AlertTriangle className="mx-auto text-amber-400" size={56} />
            <h2 className="mt-4 text-2xl font-semibold">We couldn't confirm yet</h2>
            <p className="text-white/60 mt-2">Square is still processing. Try refreshing in a few seconds, or contact support.</p>
            <button onClick={() => nav('/subscribe')} className="mt-6 px-5 py-2.5 rounded-lg bg-white text-black font-semibold">Back to plans</button>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscribeSuccess;
